import type { ReactNode } from 'react'
import { Box, Paper, Typography } from '@mui/material'
import { PRIMARY_STATE_LOGINS_GRID_TEMPLATE } from '../constants/stateLoginsLayout'

/**
 * Toolbar + mascot aligned to the same grid as the SL Logins table: mascot over **Client**,
 * speech bubble over **No Login**. Rendered outside the white table card on the page surface.
 */
export function LoginMascotBanner({ toolbar }: { toolbar: ReactNode }) {
  return (
    <Box
      sx={{
        mb: 2,
        display: 'grid',
        width: '100%',
        maxWidth: '100%',
        gridTemplateColumns: PRIMARY_STATE_LOGINS_GRID_TEMPLATE,
      }}
    >
      <Box
        sx={{
          gridColumn: 'span 5',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'flex-end',
          gap: 1,
          pb: 0.5,
        }}
      >
        {toolbar}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center', pb: 0.5 }}>
        <Box
          component="img"
          src="/misc-clippy-mascot.png"
          alt="MISC mascot"
          width={112}
          height={112}
          decoding="async"
          sx={{
            height: { xs: 96, sm: 112 },
            width: { xs: 96, sm: 112 },
            objectFit: 'contain',
          }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          minWidth: 0,
          alignItems: 'flex-end',
          justifyContent: 'center',
          px: 0.25,
          pb: 0.5,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            position: 'relative',
            maxWidth: '100%',
            borderRadius: '16px',
            border: '1px solid #e2e8f0',
            backgroundColor: '#ffffff',
            px: { xs: 1.5, sm: 1.75 },
            py: { xs: 1, sm: 1.25 },
            boxShadow: 3,
          }}
        >
          <Typography
            component="p"
            sx={{
              textAlign: 'left',
              fontSize: 12,
              fontWeight: 600,
              lineHeight: 1.375,
              color: '#1e293b',
            }}
          >
            Don&apos;t have a login yet? Check the box below and we&apos;ll walk you through creating one!
          </Typography>
          <Box
            component="span"
            aria-hidden
            sx={{
              pointerEvents: 'none',
              position: 'absolute',
              bottom: { xs: 12, sm: '14px' },
              left: -8,
              height: 0,
              width: 0,
              borderTop: '8px solid transparent',
              borderBottom: '8px solid transparent',
              borderRight: '9px solid #ffffff',
              filter: 'drop-shadow(-1px 0 0 rgb(226, 232, 240))',
            }}
          />
        </Paper>
      </Box>
    </Box>
  )
}
